@if (formGroup) {
  <form [formGroup]="formGroup" class="flex flex-col gap-4">
    <div class="flex gap-3 items-center">
      <em-select
        formControlName="rangeMode"
        [subscriptSizing]="'dynamic'"
        class="w-full"
      >
        <em-option [value]="undefined"> </em-option>
        <em-option [value]="'above'">
          {{ 'CAMPAIGN_PERFORMANCE_FILTER_ABOVE_DROPDOWN_LABEL' | translate }}
        </em-option>
        <em-option [value]="'within'">
          {{ 'CAMPAIGN_PERFORMANCE_FILTER_WITHIN_DROPDOWN_LABEL' | translate }}
        </em-option>
        <em-option [value]="'below'">
          {{ 'CAMPAIGN_PERFORMANCE_FILTER_BELOW_DROPDOWN_LABEL' | translate }}
        </em-option>
      </em-select>
      <em-more-info
        class="ml-auto"
        [maxWidth]="500"
        [description]="'CAMPAIGN_PERFORMANCE_FILTER_MODE_PRICE_V2_DESCRIPTION'"
      ></em-more-info>
    </div>

    <mat-slide-toggle formControlName="shippingCostsExcluded" color="primary">
      <span>{{
        'CAMPAIGN_PERFORMANCE_FILTER_BEST_PRICE_EXCLUDE_SHIPPING' | translate
      }}</span>
    </mat-slide-toggle>

    <mat-slide-toggle formControlName="excludeProducts" color="primary">
      <span>{{
        'CAMPAIGN_PERFORMANCE_FILTER_EXCLUDE_PRODUCTS_LABEL' | translate
      }}</span>
    </mat-slide-toggle>
  </form>
}
